import { render } from "./B6Data.vue?vue&type=template&id=366658d0&scoped=true"
import script from "./B6Data.vue?vue&type=script&lang=js"
export * from "./B6Data.vue?vue&type=script&lang=js"

import "./B6Data.vue?vue&type=style&index=0&id=366658d0&scoped=true&lang=scss"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366658d0"]])

export default __exports__